// src/composables/useImageConverter.ts
import { ref } from 'vue';

/** NEW MODAL */
import { createModal } from '@/services/modalService';
export function useModal() {

    //user 
    const modalAddUser = createModal('modal_add_user');
    const modalResetPassword = createModal('modal_reset_password');

    const modalAddOrder = createModal('modal_browser');
    const modalEditMember = createModal('modal_edit_member');

    const modalAddIncome = createModal('modal_add_income');
    const modalReglerIncome = createModal('modal_regler_income');
    const modalTransactionsIncome = createModal('modal_transactions_income');
    const modalRegulationsStatsIncome = createModal('modal_regulations_income');

    const modalAddExpense = createModal('modal_add_expense');
    const modalReglerExpense = createModal('modal_regler_expense');
    const modalTransactionsExpense = createModal('modal_transactions_expense');
    const modalRegulationsStatsExpense = createModal('modal_regulations_expense');


    const openModal = (id, action, order) => {
        if (action == "add") {
            if (id == 'modal_browser') {
                modalAddOrder?.show();
            }

            if (id == 'modal_add_income') {
                modalAddIncome?.show();
            }

            if (id == 'modal_regler_income') {
                modalReglerIncome?.show();
            }

            if (id == 'modal_add_expense') {
                console.log("hello ayb")
                modalAddExpense?.show();
            }

            if (id == 'modal_regler_expense') {
                modalReglerExpense?.show();
            }

            if (id == 'modal_add_user') {
                modalAddUser?.show();
            }
            if (id == 'modal_reset_password') {
                modalResetPassword?.show();
            }
        }


        if (action == "edit") {
            if (id == 'modal_edit_member') {
                modalEditMember?.show();
            }
            // change this
            if (id == 'modal_edit_user') {
                modalAddUser?.show();
            }
        }
        if (action == "view") {
            if (id == 'modal_transactions_income') {
                modalTransactionsIncome?.show();
            }
            if (id == 'modal_transactions_expense') {
                modalTransactionsExpense?.show();
            }

            if (id == 'modal_regulations_income') {
                modalRegulationsStatsIncome?.show();
            }
            if (id == 'modal_regulations_expense') {
                modalRegulationsStatsExpense?.show();
            }
        }

    }
    const closeModal = (id, action) => {
        if (action == "add") {
            if (id == 'modal_browser') {
                console.log("hide modal")
                modalAddOrder?.hide();
            }

            if (id == 'modal_add_income') {
                modalAddIncome?.hide();
            }

            if (id == 'modal_regler_income') {
                modalReglerIncome?.hide();
            }

            if (id == 'modal_add_expense') {
                modalAddExpense?.hide();
            }

            if (id == 'modal_regler_expense') {
                modalReglerExpense?.hide();
            }
            if (id == 'modal_add_user') {
                modalAddUser?.hide();
            }
            if (id == 'modal_reset_password') {
                modalResetPassword?.hide();
            }
        }

        if (action == "edit") {
            if (id == 'modal_edit_member') {
                modalEditMember?.hide();
            }
            //change this
            if (id == 'modal_edit_user') {
                modalAddUser?.hide();
            }
        }
        if (action == "view") {
            if (id == 'modal_transactions_income') {
                modalTransactionsIncome?.hide();
            }
            if (id == 'modal_transactions_expense') {
                modalTransactionsExpense?.hide();
            }
            if (id == 'modal_regulations_income') {
                modalRegulationsStatsIncome?.hide();
            }
            if (id == 'modal_regulations_expense') {
                modalRegulationsStatsExpense?.hide();
            }
        }
    }



    return {
        closeModal,
        openModal,
    };
}
